import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const PERSIST_KEY = 'token';

export const useUserStore = create(
    persist(
        (set) => ({
            user: null,
            setUser: (data) => set({ user: data }),
            clearUser: () => set({ user: null }),
            loading: false,
            setLoadingTrue: () => set({ loading: true }),
            setLoadingFalse: () => set({ loading: false }),
        }),
        {
            name: 'zustore',
            // getStorage: () => localStorage,
        },
    ),
);
